import moment from 'moment-jalaali'
import { useLocation, useNavigate } from 'react-router-dom'
import BackBtn from '../lib/BackBtn';

// Define the type for reportData
interface UserLog {
  id: number;
  createdAt: string;
  description: string;
  status: string;
  details: {
    matchId: string;
    profilePlatformId: string;
    ticketId: string;
  };
}

interface ReportData {
  userLogs: UserLog[];
}

function FanLogReport() {
  const navigate = useNavigate()
  const location = useLocation()
  const reportData = location.state as ReportData

  const getStatusBadge = (status: string) => {
    switch (status) {
      case '1':
        return <span className="badge badge-success">موفق</span>;
      case '0':
        return <span className="badge badge-danger">ناموفق</span>;
      default:
        return <span className="badge badge-secondary">نامشخص</span>;
    }
  };

  const goBack = () => {
    navigate("/reports/fan-list");
  };

  return (
    <div className={"card"}>
      <div
        className={
          "card-title mt-5 mb-1 px-10 d-flex align-items-center justify-content-between "
        }
      >
        <h2>تاریخچه عملیات</h2>
        <BackBtn onClick={() => goBack()} />
      </div>
      
      <div className={"card-body"}>
        <div className="table-responsive">
          <table className="table table-light table-striped">
            <thead className="fw-bold">
              <tr>
                <th>ردیف</th>
                <th>تاریخ</th>
                <th>توضیحات</th>
                <th>وضعیت</th>
                <th>جایگاه</th>
                <th>کد بلیت</th>
              </tr>
            </thead>
            <tbody>
              {reportData?.userLogs?.map((log: UserLog, index: number) => (
                <tr key={log.id}>
                  <td>{index + 1}</td>
                  <td>{moment(log.createdAt).format("jYYYY/jMM/jDD HH:mm")}</td>
                  <td>{log.description}</td>
                  <td>{getStatusBadge(log.status)}</td>
                  <td>{log.details?.profilePlatformId}</td>
                  <td>{log.details?.ticketId}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default FanLogReport